import { useLingui } from '@lingui/react/macro';

export type FindingType =
  | 'caries'
  | 'periapical_radiolucency'
  | 'calculus'
  | 'radiographic_boneloss'
  | 'area_of_concern'
  | 'restorative_adjacent_lucency';

export const useFindingSidebarTranslations = () => {
  const { t } = useLingui();

  return {
    typeToHeaderMap: {
      user: t`Did Videa AI miss something?`,
      imageQuality: t`Image quality check`,
      caries: t`Caries`,
      periapical_radiolucency: t`Periapical Radiolucency`,
      calculus: t`Calculus`,
      radiographic_boneloss: t`Radiographic Bone Level`,
      restorative_adjacent_lucency: t`Restorative Imperfections`,
      area_of_concern: t`Area of Concern`,
    },
    fdaStatusInfo: {
      radiographic_boneloss: {
        title: t`From Videa Perio Assist`,
        investigationalDevice: null,
        message: null,
      },
      caries: {
        title: t`From Videa Caries Assist`,
        investigationalDevice: t`Investigational Device for PAs`,
        message: t`Caries detection on periapical radiographs is limited by Federal (or United States) law to investigational use. (Caries detection on bitewings is FDA-cleared).`,
      },
      periapical_radiolucency: {
        title: t`From Videa Dental AI`,
        investigationalDevice: null,
        message: null,
      },
      calculus: {
        title: t`From Videa Dental AI`,
        investigationalDevice: null,
        message: null,
      },
      VDA: {
        title: t`From Videa Dental AI`,
        investigationalDevice: null,
        message: null,
      },
      restorative_adjacent_lucency: {
        title: t`From Videa Dental AI`,
        investigationalDevice: null,
        message: null,
      },
    },
    noFindingsDetectedMessage: t`No findings detected`,
  };
};
